import {
  SELECT_USER_GROUP_DATA,
  ACTION_GET_GROUP_MODEL_FACTOR,
  ACTION_GET_COMBO_STYPE_PANEL,
  GET_GROUP_PRICE_USER,
  ALL_GROUP_USER_DATA,
  ACTION_GET_GROUP_USERS_RELATION,
  USER_SEARCH,
  NAME_USER_DEFAULT,
} from "Stores/actionTypes";
import UserService from "Services/http/endpoints/user/UserService";
import StatusHandler from "Helpers/StatusHandler";
import { read } from "Helpers/LocalStorage";
import { translatorf } from "Languages/Utility/translatorf";
import showNotify from "Helpers/Notify";

export const getGroupPriceUser = (params) => {
  return async (dispatch) => {
    try {
      const response = await UserService.getGroupPriceUser(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const Grouper = response.data.Value;
        const update = Grouper.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        dispatch({
          type: GET_GROUP_PRICE_USER,
          groupPriceUser: update,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getNameUserDefault = (params) => {
  return async (dispatch) => {
    try {
      const response = await UserService.getNameUserDefault(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const name = response.data.Value;

        dispatch({
          type: NAME_USER_DEFAULT,
          nameUserDefault: name,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const selectUserGroup = (params) => {
  return async (dispatch) => {
    try {
      const response = await UserService.selectUserGroup(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const limit = response.data.Pagination.Limit;
        const page = response.data.Pagination.Page;
        const updatedData = data.map((data, index) => {
          return {
            ...data,
            num: ((page - 1 ) * limit) + index + 1,
          };
        });
        dispatch({
          type: SELECT_USER_GROUP_DATA,
          userGroupData: updatedData,
          userGroupDataPagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const editUser = (data) => {
  return async (dispatch) => {
    try {
      const response = await UserService.editUser(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('User_edited_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const postInsertUser = (data) => {
  return async () => {
    try {
      const response = await UserService.postInsertUser(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        //todo
        //dispatch(selectUserGroup());
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const deleteUser = (data) => {
  return async (dispatch) => {
    try {
      const response = await UserService.deleteUser(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('User_deleted_successfully'),
          customClass: "success"
        });
        return true;
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          //TODO api relation
        }
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const activeAction = (data) => {
  return async () => {
    try {
      const response = await UserService.activeAction(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getAllGoroupUserData = (params) => {
  return async (dispatch) => {
    try {
      const response = await UserService.getAllGoroupUserData(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const usersList = response.data.Value;
        dispatch({
          type: ALL_GROUP_USER_DATA,
          allGroupUserData: usersList,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const insertGoroupUserPriceData = (data) => {
  return async (dispatch) => {
    try {
      const response = await UserService.insertGoroupUserPriceData(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('User_group_added_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const updateGoroupUserData = (data) => {
  return async (dispatch) => {
    try {
      const response = await UserService.updateGoroupUserData(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('User_group_edited_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const deleteGoroupUserData = (data) => {
  return async (dispatch) => {
    try {
      const response = await UserService.deleteGoroupUserData(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('User_group_deleted_successfully'),
          customClass: "success"
        });
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        await dispatch(getAllGoroupUserData(params));
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
          };
          dispatch(getRelationGoroupUserData(params));
        }
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getRelationGoroupUserData = (params) => {
  return async (dispatch) => {
    try {
      const response = await UserService.getRelationGoroupUserData(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const typeRelation = response.data.Value.List;
        dispatch({
          type: ACTION_GET_GROUP_USERS_RELATION,
          dataRelationGroupUsers: typeRelation,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getComboStypePanel = (params) => {
  return async (dispatch) => {
    try {
      const response = await UserService.getComboStypePanel(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const Grouper = response.data.Value;
        const update = Grouper.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        dispatch({
          type: ACTION_GET_COMBO_STYPE_PANEL,
          dataComboStypePanel: update,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getAllGroupModelFactors = (params) => {
  return async (dispatch) => {
    try {
      const response = await UserService.getAllGroupModelFactors(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const Grouper = response.data.Value;
        const update = Grouper.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        dispatch({
          type: ACTION_GET_GROUP_MODEL_FACTOR,
          groupModelFactors: update,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const changeUsertSearch = (userGroupDataSearch) => (dispatch) => {
  dispatch({
    type: USER_SEARCH,
    userGroupDataSearch: userGroupDataSearch,
  });
};
